import {ApigwResponse} from '@shared/helpers/api'

import {ReasonType, ReasonTypeType} from '@web/core/constants'

export const FinishCode = {
    COMPLETED: 'COMPLETED',
    /** popup 차단 */
    POPUP_BLOCK: 'POPUP_BLOCK',
    /** 알지 못하는 상태에서 페이지를 떠남 */
    PAGE_UNLOAD: 'PAGE_UNLOAD',
    /** 결제 요청 검증 실패 */
    PREPARE_FAIL: 'PREPARE_FAIL',
    /** 결제 요청 실패 */
    PROCESSING_FAILURE: 'PROCESSING_FAILURE',
    /** 결제 요청 실패 (소켓 응답 크기) */
    PROCESSING_LONG_FAILURE: 'PROCESSING_LONG_FAILURE',
    /** billing 인증 실패 */
    VAN_APPROVAL_FAIL: 'VAN_APPROVAL_FAIL',
    /** 결제 한도 초과 */
    FDS_PAYMENT_SECURITY: 'FDS_PAYMENT_SECURITY',
    /** 차단 */
    FDS_BLOCKED: 'FDS_BLOCKED',
    /** FDS 인증 취소 */
    FDS_CANCEL: 'FDS_CANCEL',
    /** FDS 인증 취소 */
    FDS_PASSWORD_CHANGE: 'FDS_PASSWORD_CHANGE',
    /** 3ds 인증 실패 */
    THREE_DS_FAILURE: 'THREE_DS_FAILURE',
    /** 결제 승인 실패 */
    APPLY_FAILURE: 'APPLY_FAILURE',
    /** 권한 없음 */
    NOT_AUTHORIZED: ApigwResponse.NOT_AUTHORIZED,
    /** 약관미동의 */
    NOT_AGREE: ApigwResponse.NOT_AGREE,
    /** 이용정지 */
    TRANSACTION_STOP: ApigwResponse.TRANSACTION_STOP,
    /** 나중에 결제 배송일자 미동의 */
    NEED_HOPE_DELIVERY_NOTICE_FAIL: 'NEED_HOPE_DELIVERY_NOTICE_FAIL',
    /** BF CASH 인한 주문 프로세스 중단 */
    PERSISTED_ABORT: 'PERSISTED_ABORT',
    /** 알수 없음 */
    UNKNOWN: 'UNKNOWN',
} as const

export const DetailCauseCode = {
    /** 결제 요청 검증 실패 (세부) */
    PREPARE_API_FAIL: 'PREPARE_API_FAIL',
    PREPARE_AXIOS_FAIL: 'PREPARE_AXIOS_FAIL',
    PREPARE_AXIOS_UNKNOWN_FAIL: 'PREPARE_AXIOS_UNKNOWN_FAIL',
    PREPARE_UNKNOWN_FAIL: 'PREPARE_UNKNOWN_FAIL',
    /** 결제 요청 실패 (세부) */
    PROCESSING_API_FAIL: 'PROCESSING_API_FAIL',
    PROCESSING_AXIOS_FAIL: 'PROCESSING_AXIOS_FAIL',
    PROCESSING_AXIOS_UNKNOWN_FAIL: 'PROCESSING_AXIOS_UNKNOWN_FAIL',
    PROCESSING_UNKNOWN_FAIL: 'PROCESSING_UNKNOWN_FAIL',
    /** 결제 승인 실패 (세부) */
    APPLY_API_FAIL: 'APPLY_API_FAIL',
    APPLY_AXIOS_FAIL: 'APPLY_AXIOS_FAIL',
    APPLY_AXIOS_UNKNOWN_FAIL: 'APPLY_AXIOS_UNKNOWN_FAIL',
    APPLY_UNKNOWN_FAIL: 'APPLY_UNKNOWN_FAIL',
}

export const CauseCode = {
    SKIP: 'SKIP',
    PREVENT_OVERLAPPED_ORDER_PROCESS: 'PREVENT_OVERLAPPED_ORDER_PROCESS',
} as const

/** orderProcessor 종료 사유 */
export const FinishStatusCode = {
    ...FinishCode,
    ...DetailCauseCode,
    ...ReasonType,
}

export type FinishCodeType = Constant<typeof FinishCode>
export type DetailCauseCodeType = Constant<typeof DetailCauseCode>
export type CauseCodeType = Constant<typeof CauseCode>

export type FinishStatusCodeType = ReasonTypeType | FinishCodeType | CauseCodeType | DetailCauseCodeType
